import { SystemField } from "./system-field";

export class CurrencyPicklist extends SystemField{
    name?:string; 
    symbol?:string; 
    icon?:string; 
    code?:string; 
}
